function Carregando() {
    return(
        <div className="gray-bg" style={{display: "flex", width:"100%", height: "100%", alignContent: "center", justifyContent: "center", padding: 50}}>
            <div  style={{display: "flex", marginTop:20,  width:300, height: 400,alignItems: "center", justifyContent: "center"}}>
                <h2>Carregando..</h2>
            </div>
        </div>
    )
}
export default Carregando;